// extracted by mini-css-extract-plugin
export default {"CreateHeader":"CreateHeader_CreateHeader__7ZeO2","Desc":"CreateHeader_Desc__FHv25"};